<div class="modal-backdrop" (click)="closeModal()">
  <div class="destination-activation-modal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

    <header class="modal-header">
      <div>
        <h3>{{ 'destinations.activation.title' | translate }}</h3>
        @if (audienceName) {
          <p>{{ audienceName }}</p>
        }
      </div>
      <button type="button" class="ghost-btn compact" aria-label="Close" (click)="closeModal()">×</button>
    </header>

    <section class="modal-body">

      @if (isLoading) {
        <div class="types-loading">
          {{ 'destinations.activation.loadingDestinations' | translate }}
        </div>
      } @else {
        <div class="destination-type-list">

          @for (type of typesWithDestinations; track type.ID) {
            <div class="destination-type-item" [class.is-expanded]="isExpanded(type.ID)">

              <button type="button" class="destination-type-header" (click)="toggleType(type.ID)">
                <div class="type-info">
                  @if (getTypeIconPath(type); as iconPath) {
                    <img class="type-logo" [src]="iconPath" [alt]="type.Name || type.ActivationType" (error)="onLogoError(type.ID)">
                  } @else {
                    <span class="type-logo type-logo--fallback">{{ (type.Name || type.ActivationType).charAt(0).toUpperCase() }}</span>
                  }
                  <strong>{{ type.Name || type.Description || type.ActivationType }}</strong>
                </div>
                <span class="chevron" [class.rotated]="isExpanded(type.ID)">›</span>
              </button>

              @if (isExpanded(type.ID)) {
                <div class="destination-type-panel">
                  @if (requiresEntitySelection) {
                    <div class="activation-entity-picker">
                      <p class="activation-entity-hint">
                        {{ 'destinations.activation.selectEntityForActivation' | translate }}
                      </p>
                      <label class="form-field">
                        <span>{{ 'destinations.fields.entity' | translate }}</span>
                        <app-custom-select [ngModel]="selectedEntityId"
                                           [ngModelOptions]="{ standalone: true }"
                                           (ngModelChange)="onEntitySelected($event)"
                                           [options]="entityOptions"
                                           [searchable]="true"
                                           [placeholder]="'destinations.activation.selectEntityPlaceholder' | translate">
                        </app-custom-select>
                      </label>
                    </div>
                  }
                  @if (!isEntitySelectionPending) {
                  @let typeAlert = getAlertForType(type);
                  @if (typeAlert) {
                    <div class="activation-alert">{{ typeAlert | translate }}</div>
                  }
                  @let destinations = getDestinationsForType(type);
                  @if (destinations.length) {

                    <ul class="destination-list">
                      @for (dest of destinations; track dest.ID) {
                        <li class="destination-item">
                          <label>
                            <input type="checkbox"
                                   [checked]="isDestinationSelected(dest.ID)"
                                   [disabled]="destinations.length === 1"
                                   (change)="toggleDestination(dest.ID, $any($event.target).checked)">
                            <span>{{ dest.Name }}</span>
                          </label>
                        </li>
                      }
                    </ul>

                    @if (showActivationForm) {
                      <form class="activation-form" [formGroup]="activationForm" (ngSubmit)="onSubmit()">

                        @switch (activationParamsType) {

                          @case ('ExternalSegment') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                              <input type="text" formControlName="ExternalSegmentID">
                            </label>
                          }

                          @case ('AdformAPI') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                              <input type="text" formControlName="ExternalSegmentID">
                            </label>
                          }

                          @case ('Generic') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                              <input type="text" formControlName="ExternalSegmentID">
                            </label>
                          }

                          @case ('generic') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                              <input type="text" formControlName="ExternalSegmentID">
                            </label>
                          }

                          @case ('Pubmatic') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                              <input type="text" formControlName="ExternalSegmentID">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.pubmaticAudienceId' | translate }}</span>
                              <input type="text" formControlName="PubmaticAudienceID">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.audienceName' | translate }}</span>
                              <input type="text" formControlName="Name">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.description' | translate }}</span>
                              <input type="text" formControlName="Description">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.country' | translate }}</span>
                              <app-custom-select formControlName="Country"
                                                 [options]="countryOptions"
                                                 [searchable]="true">
                              </app-custom-select>
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.price' | translate }}</span>
                              <input type="text" formControlName="Price">
                            </label>
                          }

                          @case ('TheTradeDesk') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.audienceName' | translate }}</span>
                              <input type="text" formControlName="CustomAudienceName">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.description' | translate }}</span>
                              <input type="text" formControlName="CustomAudienceDesc">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                              <input type="text" formControlName="ExternalSegmentID">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.externalSegmentParentId' | translate }}</span>
                              <input type="text" formControlName="ExternalSegmentParentID">
                            </label>
                            <div class="form-row">
                              <label class="form-field">
                                <span>{{ 'destinations.fields.cpmRateAmount' | translate }}</span>
                                <input type="number" formControlName="CPMRateAmount" step="0.01">
                              </label>
                              <label class="form-field">
                                <span>{{ 'destinations.fields.cpmCurrency' | translate }}</span>
                                <app-custom-select formControlName="CPMRateCurrencyCode"
                                                   [options]="ttdCurrencyOptions">
                                </app-custom-select>
                              </label>
                            </div>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.percentOfMediaCost' | translate }}</span>
                              <input type="number" formControlName="PercentOfMediaCostRate" step="0.01">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.rateLevel' | translate }}</span>
                              <app-custom-select formControlName="RateLevel"
                                                 [options]="rateLevelOptions">
                              </app-custom-select>
                            </label>
                            @if (rateLevelValue === 'Partner') {
                              <label class="form-field">
                                <span>{{ 'destinations.fields.partnerId' | translate }}</span>
                                <input type="text" formControlName="PartnerId">
                              </label>
                            }
                            @if (rateLevelValue === 'Advertiser') {
                              <label class="form-field">
                                <span>{{ 'destinations.fields.advertiserId' | translate }}</span>
                                <input type="text" formControlName="AdvertiserId">
                              </label>
                            }
                            <label class="form-field form-field--checkbox">
                              <input type="checkbox" formControlName="Buyable">
                              <span>{{ 'destinations.fields.buyable' | translate }}</span>
                            </label>
                          }

                          @case ('TheTradeDesk1pd') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.audienceName' | translate }}</span>
                              <input type="text" formControlName="CustomAudienceName">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.region' | translate }}</span>
                              <app-custom-select formControlName="Region"
                                                 [options]="ttd1pdRegionOptions">
                              </app-custom-select>
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.segmentType' | translate }}</span>
                              <app-custom-select formControlName="SegmentType"
                                                 [options]="ttd1pdSegmentTypeOptions">
                              </app-custom-select>
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.mergeMode' | translate }}</span>
                              <app-custom-select formControlName="MergeMode"
                                                 [options]="ttd1pdMergeModeOptions">
                              </app-custom-select>
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.advertiserId' | translate }}</span>
                              <input type="text" formControlName="AdvertiserID">
                            </label>
                          }

                          @case ('TheTradeDeskOfflineConversion') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.trackingTagName' | translate }}</span>
                              <input type="text" formControlName="TrackingTagName">
                            </label>
                          }

                          @case ('AudienceRealtime') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.externalAudienceName' | translate }}</span>
                              <input type="text" formControlName="ExternalAudienceName">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.description' | translate }}</span>
                              <input type="text" formControlName="Description">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.ttl' | translate }}</span>
                              <input type="number" formControlName="TTL" min="1">
                            </label>
                          }

                          @case ('Zeotap') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.zeotapAccountType' | translate }}</span>
                              <app-custom-select formControlName="AccountType"
                                                 [options]="zeotapAccountTypeOptions">
                              </app-custom-select>
                            </label>
                            @if (zeotapAccountTypeValue === 'Marketplace') {
                              <label class="form-field">
                                <span>{{ 'destinations.fields.zeotapSegmentId' | translate }}</span>
                                <input type="text" formControlName="ExternalSegmentID">
                              </label>
                            }
                            @if (zeotapAccountTypeValue === 'Advertiser') {
                              <label class="form-field">
                                <span>{{ 'destinations.fields.segmentName' | translate }}</span>
                                <input type="text" formControlName="SegmentName">
                              </label>
                              <label class="form-field">
                                <span>{{ 'destinations.fields.description' | translate }}</span>
                                <input type="text" formControlName="Description">
                              </label>
                              <label class="form-field">
                                <span>{{ 'destinations.fields.cpmPrice' | translate }}</span>
                                <input type="number" formControlName="Price" step="0.01" min="0">
                              </label>
                              <label class="form-field">
                                <span>{{ 'destinations.fields.countries' | translate }}</span>
                                <app-custom-select formControlName="Countries"
                                                   [options]="countryOptions"
                                                   [multiple]="true"
                                                   [searchable]="true">
                                </app-custom-select>
                              </label>
                              <label class="form-field">
                                <span>{{ 'destinations.fields.zeotapDestinationId' | translate }}</span>
                                <input type="text" formControlName="ZeotapDestinationID">
                              </label>
                            }
                          }

                          @default {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                              <input type="text" formControlName="ExternalSegmentID">
                            </label>
                          }

                        }

                        @if (hasGlobalDataAccess) {
                          <label class="form-field form-field--checkbox">
                            <input type="checkbox" formControlName="ExcludeControlGroup">
                            <span>{{ 'destinations.fields.excludeControlGroup' | translate }}</span>
                          </label>
                        }

                        <div class="form-actions">
                          <button type="submit" class="primary-btn"
                                  [disabled]="activationForm.invalid || isSubmitting">
                            {{ isSubmitting ? ('common.processing' | translate) : ('destinations.activateButton' | translate) }}
                          </button>
                        </div>

                      </form>
                    }

                  } @else {
                    @if (showRequestActivationForm) {
                      <form class="activation-form activation-form--request"
                            [formGroup]="requestActivationForm"
                            (ngSubmit)="onRequestActivation()">

                        <p class="request-activation-hint">
                          {{ (expandedType?.PermissionType === 'assisted-service'
                            ? 'destinations.activation.requestHintAssistedService'
                            : 'destinations.activation.requestHint') | translate }}
                        </p>

                        @switch (requestActivationParamsType) {

                          @case ('Infosum') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.companyId' | translate }}</span>
                              <input type="text" formControlName="CompanyID"
                                     [placeholder]="'destinations.fields.companyIdPlaceholder' | translate">
                            </label>
                          }

                          @case ('Adform') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.country' | translate }}</span>
                              <input type="text" formControlName="Country">
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.accountName' | translate }}</span>
                              <input type="text" formControlName="AccountName">
                            </label>
                          }

                          @case ('AudienceRate') {
                            <label class="form-field">
                              <span>{{ 'destinations.dv360.accountType' | translate }}</span>
                              <app-custom-select formControlName="AccountType"
                                                 [options]="dv360AccountTypeOptions"
                                                 [placeholder]="'destinations.dv360.accountTypePlaceholder' | translate">
                              </app-custom-select>
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.accountId' | translate }}</span>
                              <input type="text" formControlName="AccountID">
                            </label>
                          }

                          @case ('Pubmatic') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.accountType' | translate }}</span>
                              <app-custom-select formControlName="AccountType"
                                                 [options]="pubmaticRequestAccountTypeOptions"
                                                 [placeholder]="'destinations.fields.accountTypePlaceholder' | translate">
                              </app-custom-select>
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.accountId' | translate }}</span>
                              <input type="text" formControlName="AccountID">
                            </label>
                          }

                          @case ('TheTradeDesk') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.accountType' | translate }}</span>
                              <app-custom-select formControlName="AccountType"
                                                 [options]="ttdRequestAccountTypeOptions"
                                                 [placeholder]="'destinations.fields.accountTypePlaceholder' | translate">
                              </app-custom-select>
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.accountId' | translate }}</span>
                              <input type="text" formControlName="AccountID">
                            </label>
                          }

                          @case ('TheTradeDesk1pd') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.accountType' | translate }}</span>
                              <app-custom-select formControlName="AccountType"
                                                 [options]="ttdRequestAccountTypeOptions"
                                                 [placeholder]="'destinations.fields.accountTypePlaceholder' | translate">
                              </app-custom-select>
                            </label>
                            <label class="form-field">
                              <span>{{ 'destinations.fields.accountId' | translate }}</span>
                              <input type="text" formControlName="AccountID">
                            </label>
                          }

                          @case ('Zeotap') {
                            <label class="form-field">
                              <span>{{ 'destinations.fields.advertiserName' | translate }}</span>
                              <input type="text" formControlName="AdvertiserName">
                            </label>
                          }

                          @default {
                          }

                        }

                        <div class="form-actions">
                          <button type="submit" class="primary-btn"
                                  [disabled]="isRequestingActivation">
                            {{ isRequestingActivation
                              ? ('common.processing' | translate)
                              : ('destinations.activation.requestButton' | translate) }}
                          </button>
                        </div>

                      </form>
                    } @else {
                      <p class="no-destinations">{{ 'destinations.activation.noDestinationsForType' | translate }}</p>
                    }
                  }
                  } <!-- end @if (!isEntitySelectionPending) -->
                </div>
              }

            </div>
          } @empty {
            <p class="empty-state">{{ 'destinations.activation.noTypes' | translate }}</p>
          }

          @if (typesWithoutDestinations.length > 0) {
            <p class="section-label section-label--disabled">{{ 'destinations.activation.noDestinationsAvailable' | translate }}</p>
            @for (type of typesWithoutDestinations; track type.ID) {
              <div class="destination-type-item" [class.is-expanded]="isExpanded(type.ID)">

                <button type="button" class="destination-type-header" (click)="toggleType(type.ID)">
                  <div class="type-info">
                    @if (getTypeIconPath(type); as iconPath) {
                      <img class="type-logo" [src]="iconPath" [alt]="type.Name || type.ActivationType" (error)="onLogoError(type.ID)">
                    } @else {
                      <span class="type-logo type-logo--fallback">{{ (type.Name || type.ActivationType).charAt(0).toUpperCase() }}</span>
                    }
                    <strong>{{ type.Name || type.Description || type.ActivationType }}</strong>
                  </div>
                  <span class="chevron" [class.rotated]="isExpanded(type.ID)">›</span>
                </button>

                @if (isExpanded(type.ID) && showRequestActivationForm) {
                  <div class="destination-type-panel">
                    @let typeAlert = getAlertForType(type);
                    @if (typeAlert) {
                      <div class="activation-alert">{{ typeAlert | translate }}</div>
                    }
                    <form class="activation-form activation-form--request"
                          [formGroup]="requestActivationForm"
                          (ngSubmit)="onRequestActivation()">

                      <p class="request-activation-hint">
                        {{ (expandedType?.PermissionType === 'assisted-service'
                          ? 'destinations.activation.requestHintAssistedService'
                          : 'destinations.activation.requestHint') | translate }}
                      </p>

                      @switch (requestActivationParamsType) {

                        @case ('Infosum') {
                          <label class="form-field">
                            <span>{{ 'destinations.fields.companyId' | translate }}</span>
                            <input type="text" formControlName="CompanyID"
                                   [placeholder]="'destinations.fields.companyIdPlaceholder' | translate">
                          </label>
                        }

                        @case ('Adform') {
                          <label class="form-field">
                            <span>{{ 'destinations.fields.country' | translate }}</span>
                            <input type="text" formControlName="Country">
                          </label>
                          <label class="form-field">
                            <span>{{ 'destinations.fields.accountName' | translate }}</span>
                            <input type="text" formControlName="AccountName">
                          </label>
                        }

                        @case ('AudienceRate') {
                          <label class="form-field">
                            <span>{{ 'destinations.dv360.accountType' | translate }}</span>
                            <app-custom-select formControlName="AccountType"
                                               [options]="dv360AccountTypeOptions"
                                               [placeholder]="'destinations.dv360.accountTypePlaceholder' | translate">
                            </app-custom-select>
                          </label>
                          <label class="form-field">
                            <span>{{ 'destinations.fields.accountId' | translate }}</span>
                            <input type="text" formControlName="AccountID">
                          </label>
                        }

                        @case ('Pubmatic') {
                          <label class="form-field">
                            <span>{{ 'destinations.fields.accountType' | translate }}</span>
                            <app-custom-select formControlName="AccountType"
                                               [options]="pubmaticRequestAccountTypeOptions"
                                               [placeholder]="'destinations.fields.accountTypePlaceholder' | translate">
                            </app-custom-select>
                          </label>
                          <label class="form-field">
                            <span>{{ 'destinations.fields.accountId' | translate }}</span>
                            <input type="text" formControlName="AccountID">
                          </label>
                        }

                        @case ('TheTradeDesk') {
                          <label class="form-field">
                            <span>{{ 'destinations.fields.accountType' | translate }}</span>
                            <app-custom-select formControlName="AccountType"
                                               [options]="ttdRequestAccountTypeOptions"
                                               [placeholder]="'destinations.fields.accountTypePlaceholder' | translate">
                            </app-custom-select>
                          </label>
                          <label class="form-field">
                            <span>{{ 'destinations.fields.accountId' | translate }}</span>
                            <input type="text" formControlName="AccountID">
                          </label>
                        }

                        @case ('TheTradeDesk1pd') {
                          <label class="form-field">
                            <span>{{ 'destinations.fields.accountType' | translate }}</span>
                            <app-custom-select formControlName="AccountType"
                                               [options]="ttdRequestAccountTypeOptions"
                                               [placeholder]="'destinations.fields.accountTypePlaceholder' | translate">
                            </app-custom-select>
                          </label>
                          <label class="form-field">
                            <span>{{ 'destinations.fields.accountId' | translate }}</span>
                            <input type="text" formControlName="AccountID">
                          </label>
                        }

                        @case ('Zeotap') {
                          <label class="form-field">
                            <span>{{ 'destinations.fields.advertiserName' | translate }}</span>
                            <input type="text" formControlName="AdvertiserName">
                          </label>
                        }

                        @default {
                        }

                      }

                      <div class="form-actions">
                        <button type="submit" class="primary-btn"
                                [disabled]="isRequestingActivation">
                          {{ isRequestingActivation
                            ? ('common.processing' | translate)
                            : ('destinations.activation.requestButton' | translate) }}
                        </button>
                      </div>

                    </form>
                  </div>
                }

              </div>
            }
          }

        </div>
      }

    </section>

  </div>
</div>
